export default __webpack_public_path__ + "media/faq/faq_awards_screenshot_1_alt-394443dc.png";